import { Red5Player } from '@optools/components/players/red5-player';
import { useState } from 'react';

import { Red5PlayerSourceForm, Red5PlayerSourceFormType } from './red-5-player-source-form';

export function Red5CardContent() {
  const [playerSource, setPlayerSource] = useState<Red5PlayerSourceFormType | undefined>(undefined);
  const handleSubmit = (values: Red5PlayerSourceFormType) => {
    setPlayerSource(values);
  };

  return (
    <div className="flex flex-col gap-4 p-2">
      <Red5PlayerSourceForm onSubmit={handleSubmit} />
      {playerSource ? (
        <Red5Player
          host={playerSource.host}
          nodeGroup={playerSource.nodeGroup}
          streamName={playerSource.streamName}
        />
      ) : (
        <div className="flex aspect-video h-full w-full items-center justify-center rounded-lg bg-muted">
          <h3 className="text-sm font-medium text-muted-foreground">
            Enter Player Source to View Playback
          </h3>
        </div>
      )}
    </div>
  );
}
